import { motion } from 'framer-motion';
import { Card } from 'antd';
import { Link } from 'react-router-dom';
import React from 'react';

const Cards = ({ cardData }) => {
  const scrollVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        type: "spring",
        stiffness: 50
      }
    }
  };
  
  return (
    <motion.div
      className="cards-wrapper"
      variants={scrollVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <div className="cards-container">
        {cardData.map((item, index) => (
          <motion.div
            key={index}
            className="card"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Card hoverable className="info-card" style={item.style}>
              {item.icon}
              <h3 style={{backdropFilter:'blur(3px'}}>{item.title}</h3>
              <Link to={item.link} className="card-link" >Explore</Link>
            </Card>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Cards;